var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 16c0-8.83656-7.1634-16-16-16-8.83656 0-16 7.16344-16 16 0 8.8366 7.16344 16 16 16 8.8366 0 16-7.1634 16-16z",
    fill: "#9146ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.0021 9.42813-2.8571 2.85717v10.2857h3.4286v2.8571l2.8571-2.8571h2.2857l5.1429-5.1429v-7.99997zm9.7143 7.42857-2.2857 2.2857h-2.2857l-2 2v-2h-2.5714v-8.5714h9.1428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.0021 12.571h-1.1428v3.4286h1.1428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.8593 12.571h-1.1429v3.4286h1.1429z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.87828011390ca81f68a83e545b1243da.svg";
export { ForwardRef as ReactComponent };